import React from "react";
import { Outlet, useLoaderData } from "react-router-dom";
import TabLayout from "../../../helpers/TabLayout";

const ContactLayout = () => {
  const { contact } = useLoaderData();
  return (
    <>
      <TabLayout
        headerLabel={contact.email || "Contact"}
        skeletonLines={14}
      >
        <Outlet/>
      </TabLayout>
    </>
  );
};

export default ContactLayout;